import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_cart",
  "use": "svg_cart-usage",
  "viewBox": "0 0 20 22",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 22\" id=\"svg_cart\"><path d=\"m1 5 3-4h12l3 4M1 5v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5M1 5h18m-5 4a4 4 0 1 1-8 0\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol